export default {
  NOTICE: 'notice',
  SUCCESS: 'success',
  WARNING: 'warning',
  ALERT: 'alert',
} as const
